import * as React from 'react';
import { IconProps } from '../types';

const IcHome1 = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M6.312 9.75c.31 0 .563.265.563.591v8.726h2.812V14.63c0-.392.148-.768.412-1.045.264-.278.621-.434.994-.434h2.813c.373 0 .73.156.994.434.264.277.412.653.412 1.045v4.437h2.813V10.34c0-.326.251-.591.562-.591.31 0 .563.265.563.591v8.726c0 .314-.119.615-.33.837a1.098 1.098 0 0 1-.796.346H14.75c-.311 0-.563-.265-.563-.591V14.63a.304.304 0 0 0-.082-.209.274.274 0 0 0-.2-.086h-2.812a.275.275 0 0 0-.199.086.304.304 0 0 0-.082.21v5.027c0 .327-.252.592-.563.592H6.875c-.299 0-.585-.125-.796-.346a1.215 1.215 0 0 1-.33-.837V10.34c0-.326.252-.591.563-.591Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="m13.331 4.074 2.168 2.076v-1.2a.6.6 0 0 1 .6-.6h1.8a.6.6 0 0 1 .6.6v4.072l2.815 2.694a.6.6 0 1 1-.83.867l-7.973-7.632a.134.134 0 0 0-.023 0l-7.974 7.632a.6.6 0 1 1-.83-.867l7.985-7.643c.244-.248.578-.323.833-.323.254 0 .586.077.829.324Zm3.968 3.799V5.549h-.6V7.3l.6.574Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcHome1;
